import { useEffect, useState } from 'react';
import {
  AuditStatus,
  AuditType,
  MitarbeiterList,
  ProjektList,
} from '../../../types';
import {
  auditStatusService,
  auditTypesService,
} from '../../../services/lookupService';
import { mitarbeiterService } from '../../../services/mitarbeiterService';
import { projekteService } from '../../../services/projekteService';

export const useAuditLookups = () => {
  const [projekte, setProjekte] = useState<ProjektList[]>([]);
  const [mitarbeiter, setMitarbeiter] = useState<MitarbeiterList[]>([]);
  const [auditTypes, setAuditTypes] = useState<AuditType[]>([]);
  const [auditStatuses, setAuditStatuses] = useState<AuditStatus[]>([]);
  const [loadingLookups, setLoadingLookups] = useState(true);

  useEffect(() => {
    const loadLookups = async () => {
      try {
        setLoadingLookups(true);
        const [projekteData, mitarbeiterData, auditTypesData, auditStatusesData] =
          await Promise.all([
            projekteService.list(),
            mitarbeiterService.list({ rolle: 'Pentester' }),
            auditTypesService.list(),
            auditStatusService.list(),
          ]);

        setProjekte(projekteData);
        setMitarbeiter(mitarbeiterData);
        setAuditTypes(auditTypesData);
        setAuditStatuses(auditStatusesData);
      } catch (error) {
        console.error('Fehler beim Laden der Lookup-Daten:', error);
      } finally {
        setLoadingLookups(false);
      }
    };

    void loadLookups();
  }, []);

  return {
    projekte,
    mitarbeiter,
    auditTypes,
    auditStatuses,
    loadingLookups,
  };
};
